/*
  News slider
*/

export function newsSlider() {
  $('.news-section').each(function () {
    if (matchMedia('screen and (max-width: 992px)').matches) {
      $(this).find('.news-items-wrp').flickity({
        pageDots: false,
        prevNextButtons: true,
        wrapAround: true,
        adaptiveHeight: false,
        watchCSS: true,
        cellAlign: 'left',
      });

      $(this).find('.news-items-wrp .flickity-button').appendTo($(this).find('.pagination-controller'));
    }
  });
}